import {makeAutoObservable} from "mobx";

class LookAroundStore {
    list = [];
    PAGE_SIZE = 6;
    pageSize = this.PAGE_SIZE;
    pageNum = 1;
    loading = false;

    constructor() {
        makeAutoObservable(this)
    }
}

class PaySuccessStore {
    lookAround = new LookAroundStore();

    constructor() {
        makeAutoObservable(this)
    }
}

export default new PaySuccessStore();